import { useEffect, useState } from "react";
import { useI18n } from "../../../i18n";
import { api } from "../../../lib/api";

// Start a new conversation with any customer the user may see
export const CustomerSelect = ({ onPick }) => {
  const { t } = useI18n();
  const [list, setList] = useState([]);
  useEffect(() => {
    api.get("/customers").then((r) => setList(r.data)).catch(() => {});
  }, []);
  return (
    <select value="" onChange={(e) => e.target.value && onPick(e.target.value)} data-testid="chat-new-select"
      className="h-11 w-full min-w-0 rounded-xl border border-slate-200 bg-white px-3 text-sm text-navy">
      <option value="">{t("x.chat.newChat")}</option>
      {list.map((c) => <option key={c.code} value={c.code}>{c.code} · {c.legal_name || c.name}</option>)}
    </select>
  );
};
